import { useMutation } from '@tanstack/react-query';
import { createPortalSession } from '../services/api';

export const usePortalSession = () => {
  return useMutation({
    mutationFn: async (returnUrl?: string) => {
      const data = await createPortalSession(returnUrl);
      return data;
    },
    onSuccess: (data) => {
      // Open the portal URL in a new tab
      if (data.url) {
        window.open(data.url, '_blank', 'noopener,noreferrer');
      }
    },
    onError: (error) => {
      console.error('Error creating portal session:', error);
    }
  });
}; 